export enum DemoFormVersion {
  DEFAULT = "default",
  VERSION_07251 = "07251", // copy for subheader
  VERSION_07252 = "07252", // copy for subheader
  VERSION_07253 = "07253", // navbar control
  VERSION_07254 = "07254", // navbar removed
  VERSION_08252 = "08252" // 2 steps demo form
}

export interface DemoFormCopyContent {
  firstStep: {
    subheader: string;
  };
}

type DemoFormCopyMap = {
  [DemoFormVersion.DEFAULT]: DemoFormCopyContent;
} & Partial<Record<DemoFormVersion, DemoFormCopyContent>>;

export const DEMO_FORM_COPY: DemoFormCopyMap = {
  [DemoFormVersion.DEFAULT]: {
    firstStep: {
      subheader: "See if DoorLoop is the right fit!"
    }
  },
  [DemoFormVersion.VERSION_07251]: {
    firstStep: {
      subheader: "Your custom demo is a few clicks away. Fill out the form to get started."
    }
  },
  [DemoFormVersion.VERSION_07252]: {
    firstStep: {
      subheader: "Get ready to slash admin work by a third."
    }
  }
} as const;

export function getDemoFormCopy(version: DemoFormVersion): DemoFormCopyContent {
  return DEMO_FORM_COPY[version] || DEMO_FORM_COPY[DemoFormVersion.DEFAULT];
}
